////////////////////////////////////////////
//
// Hero Video Functions
//
////////////////////////////////////////////

if ($(".hero__video-player").length) {

  var $video = $('#hero-video');
  var $playBtn = $('.js-play-herovideo');
  var $closeBtn = $('.js-close-herovideo');
  var $hero = $('.hero');
  var $heroBgVideo = $('#hero-bg-video');

  $playBtn.on('click', function() {
    playVideo();
  });

  $closeBtn.on('click', function() {
    pauseVideo();
  });

  function playVideo() {
    $heroBgVideo.trigger('pause');
    $video.trigger('play');
    $hero.addClass('is-playing-video');
  }

  function pauseVideo() {
    document.removeEventListener('fullscreenchange', pauseVideo, true);
    $video.trigger('pause');
    $hero.removeClass('is-playing-video');
    $heroBgVideo.trigger('play');
  }

}
